$(document).ready(function() {
  const cartItemCountBadge = document.querySelector('.js-cart-item-count');

  function updateCartUI(cartData) {
    if (cartItemCountBadge) {
      cartItemCountBadge.textContent = cartData.item_count;
    }
  }

  // Homepage Add to Cart functionality
  const homepageCollectionSection = document.querySelector('.homepagecollection');

//   if (homepageCollectionSection) {
    // $(homepageCollectionSection).on('click', '.js-add-to-cart', function(e) {
    //   e.preventDefault();

    //   const button = $(this);
    //   const variantId = button.data('productVariantId');
    //   const quantityInput = button.siblings('.js-qty-input');
    //   const quantity = parseInt(quantityInput.val(), 10) || 1;

    //   if (!variantId) {
    //     console.error('Variant ID not found for Add to Cart button.');
    //     return;
    //   }

    //   button.prop('disabled', true).addClass('loading');
    //   button.find('span').text('Adding...');

    //   $.ajax({
    //     type: 'POST',
    //     url: '/cart/add.js',
    //     data: {
    //       id: variantId,
    //       quantity: quantity
    //     },
    //     dataType: 'json',
    //     success: function(item) {
    //       console.log('Product added to cart:', item);
    //       button.prop('disabled', false).removeClass('loading');
    //       button.find('span').text('Added!');
         
    //       fetch('/cart.js')
    //         .then(response => response.json())
    //         .then(latestCart => {
    //             updateCartUI(latestCart);
    //         })
    //         .catch(error => console.error('Error fetching latest cart:', error));

    //       setTimeout(function() {
    //         button.find('span').text('<i class="fas fa-shopping-cart"></i> ADD TO CART');
    //       }, 1500);
    //     },
    //     error: function(jqXHR, textStatus, errorThrown) {
    //       console.error('Error adding to cart:', textStatus, errorThrown, jqXHR);
    //       button.prop('disabled', false).removeClass('loading');
    //       button.find('span').text('Error!');
    //       setTimeout(function() {
    //         button.find('span').text('<i class="fas fa-shopping-cart"></i> ADD TO CART');
    //       }, 1500);
    //       alert('Error adding product to cart. Please try again.');
    //     }
    //   });
    // });

    // $(homepageCollectionSection).on('change', '.js-qty-input', function() {
    //   if (parseInt($(this).val(), 10) < 1) {
    //     $(this).val(1);
    //   }
    // });
//   }
// Universal Add to Cart handler - works anywhere on the page
$(document).on('click', '.js-add-to-cart', function(e) {
  e.preventDefault();
  
  const button = $(this);
  const variantId = button.data('productVariantId');
  const quantityInput = button.siblings('.js-qty-input');
  const quantity = parseInt(quantityInput.val(), 10) || 1;
  
  if (!variantId) {
    console.error('Variant ID not found for Add to Cart button.');
    return;
  }
  
  button.prop('disabled', true).addClass('loading');
  button.find('span').text('Adding...');
  
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      id: variantId,
      quantity: quantity
    },
    dataType: 'json',
    success: function(item) {
      console.log('Product added to cart:', item);
      button.prop('disabled', false).removeClass('loading');
      button.find('span').text('Added!');
      
      // Update cart UI with latest cart data
      fetch('/cart.js')
        .then(response => response.json())
        .then(latestCart => {
          updateCartUI(latestCart);
        })
        .catch(error => console.error('Error fetching latest cart:', error));
      
      // Reset button text after 1.5 seconds
      setTimeout(function() {
        button.find('span').text('<i class="fas fa-shopping-cart"></i> ADD TO CART');
      }, 1500);
    },
    error: function(jqXHR, textStatus, errorThrown) {
      console.error('Error adding to cart:', textStatus, errorThrown, jqXHR);
      button.prop('disabled', false).removeClass('loading');
      button.find('span').text('Error!');
      setTimeout(function() {
        button.find('span').text('<i class="fas fa-shopping-cart"></i> ADD TO CART');
      }, 1500);
      alert('Error adding product to cart. Please try again.');
    }
  });
});

// Universal quantity input handler - works anywhere on the page
$(document).on('change', '.js-qty-input', function() {
  if (parseInt($(this).val(), 10) < 1) {
    $(this).val(1);
  }
});
  
  // Cart Page Functionality
  const cartForm = document.getElementById('cart-form');
  
  if (cartForm) {
    // Handle quantity changes with debouncing
    let updateTimeout;
    
    $(cartForm).on('change', '[data-quantity-input]', function() {
      const input = $(this);
      const newQuantity = parseInt(input.val(), 10);
      const itemKey = input.data('cart-item-key');
      const line = input.data('line');
      
      if (newQuantity < 0) {
        input.val(0);
        return;
      }
      
      clearTimeout(updateTimeout);
      updateTimeout = setTimeout(() => {
        updateCartItem(itemKey, newQuantity, line);
      }, 500);
    });

    // Handle plus/minus buttons
    $(cartForm).on('click', '[data-quantity-change]', function(e) {
      e.preventDefault();
      const button = $(this);
      const change = parseInt(button.data('quantity-change'), 10);
      const input = button.siblings('[data-quantity-input]');
      const currentQty = parseInt(input.val(), 10) || 0;
      const newQty = Math.max(0, currentQty + change);
      
      input.val(newQty).trigger('change');
    });

    // Handle remove item buttons
    $(cartForm).on('click', '[data-remove-item]', function(e) {
      e.preventDefault();
      const button = $(this);
      const itemKey = button.data('item-key');
      
      if (confirm('Are you sure you want to remove this item?')) {
        updateCartItem(itemKey, 0);
      }
    });

    // Function to update cart items via AJAX
    function updateCartItem(itemKey, quantity, line = null) {
      const cartItem = line ? $(`.cart-item[data-line="${line}"]`) : $(`.cart-item[data-item-key="${itemKey}"]`);
      
      // Show loading state
      cartItem.addClass('updating');
      
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          id: itemKey,
          quantity: quantity
        },
        dataType: 'json',
        success: function(cart) {
          console.log('Cart updated:', cart);
          
          if (quantity === 0) {
            // Remove item from DOM with animation
            cartItem.fadeOut(300, function() {
              $(this).remove();
              
              // Check if cart is now empty
              if (cart.item_count === 0) {
                location.reload(); // Refresh to show empty cart message
              }
            });
          } else {
            // Update item display
            updateCartItemDisplay(cartItem, cart, itemKey);
          }
          
          // Update cart UI
          updateCartUI(cart);
          updateCartSummary(cart);
          location.reload();
          
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.error('Error updating cart:', textStatus, errorThrown);
          cartItem.removeClass('updating');
          alert('Error updating cart. Please try again.');
          
          // Revert quantity input to previous value
          if (line) {
            const input = cartItem.find('[data-quantity-input]');
            const originalQty = cart.items.find(item => item.key === itemKey)?.quantity || 1;
            input.val(originalQty);
          }
        }
      });
    }

    // Function to update individual cart item display
    function updateCartItemDisplay(cartItem, cart, itemKey) {
      const updatedItem = cart.items.find(item => item.key === itemKey);
      
      if (updatedItem) {
        // Update line price using Shopify's formatted price
        const priceElement = cartItem.find('.cart-item__price');
        
        // Try to get formatted price from the updated cart data
        // Shopify's cart.js response includes formatted prices
        if (updatedItem.line_price_formatted) {
          priceElement.text(updatedItem.line_price_formatted);
        } else if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          // Use Shopify's built-in money formatter if available
          priceElement.text(Shopify.formatMoney(updatedItem.line_price));
        } else {
          // Fallback: fetch the formatted price from the server
          fetchFormattedPrice(updatedItem.line_price).then(formattedPrice => {
            priceElement.text(formattedPrice);
          });
        }
        
        // Update quantity input
        const qtyInput = cartItem.find('[data-quantity-input]');
        qtyInput.val(updatedItem.quantity);
      }
      
      cartItem.removeClass('updating');
    }

    // Function to update cart summary
    function updateCartSummary(cart) {
      const subtotalPrice = $('.cart-subtotal__price');
      if (subtotalPrice.length) {
        // Use formatted total price from cart response
        if (cart.total_price_formatted) {
          subtotalPrice.text(cart.total_price_formatted);
        } else if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          subtotalPrice.text(Shopify.formatMoney(cart.total_price));
        } else {
          // Fallback: fetch formatted price
          fetchFormattedPrice(cart.total_price).then(formattedPrice => {
            subtotalPrice.text(formattedPrice);
          });
        }
      }
    }

    // Function to fetch properly formatted price from server
    async function fetchFormattedPrice(priceInCents) {
      try {
        // Create a temporary URL to get formatted price
        const response = await fetch('/cart.js');
        const cartData = await response.json();
        
        // Find a cart item to get the currency format
        if (cartData.items && cartData.items.length > 0) {
          const sampleItem = cartData.items[0];
          const ratio = priceInCents / sampleItem.line_price;
          
          // Extract currency symbol and format from existing formatted price
          if (sampleItem.line_price_formatted || sampleItem.price_formatted) {
            const formattedSample = sampleItem.line_price_formatted || sampleItem.price_formatted;
            const currencyMatch = formattedSample.match(/[^\d.,\s]+/);
            const currency = currencyMatch ? currencyMatch[0] : '';
            
            // Format the price maintaining the same currency
            const amount = (priceInCents / 100).toFixed(2);
            const isPrefix = formattedSample.indexOf(currency) === 0;
            
            return isPrefix ? `${currency}${amount}` : `${amount}${currency}`;
          }
        }
        
        // Ultimate fallback
        return `$${(priceInCents / 100).toFixed(2)}`;
      } catch (error) {
        console.error('Error fetching formatted price:', error);
        return `$${(priceInCents / 100).toFixed(2)}`;
      }
    }

    // Handle cart notes
    const cartNotesTextarea = $('#CartSpecialInstructions');
    let notesTimeout;
    
    cartNotesTextarea.on('input', function() {
      clearTimeout(notesTimeout);
      notesTimeout = setTimeout(() => {
        const notes = $(this).val();
        
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {
            note: notes
          },
          dataType: 'json',
          success: function(cart) {
            console.log('Cart notes updated');
          },
          error: function() {
            console.error('Error updating cart notes');
          }
        });
      }, 1000);
    });
  }

  updateCartUI();
});


// Ensure the script runs after the DOM is fully loaded using jQuery's ready function
// $(function() {
//   const $wishlistCountSpan = $('.js-wishlist-count');

//   const $productWishlistToggles = $('.js-wishlist-toggle');

//   let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

//   const updateWishlistCount = () => {
//     if ($wishlistCountSpan.length) {
//       $wishlistCountSpan.text(wishlist.length);
//     }
//   };


//   const updateProductHeartIcon = (productId, isWishlisted) => {
//     const $productToggleIcon = $(`.js-wishlist-toggle[data-product-id="${productId}"] i`);
//     if ($productToggleIcon.length) {
//       if (isWishlisted) {
//         $productToggleIcon.removeClass('far').addClass('fas');
//       } else {
//         $productToggleIcon.removeClass('fas').addClass('far');
//       }
//     }
//   };


//   const initializeWishlist = () => {
//     wishlist.forEach(productId => {
//       updateProductHeartIcon(productId, true);
//     });
//     updateWishlistCount();
//   };

//   $productWishlistToggles.on('click', function(event) {
//     event.preventDefault();

//     const productId = $(this).data('product-id');

//     if (productId) {
//       const index = wishlist.indexOf(productId.toString());

//       if (index > -1) {
//         wishlist.splice(index, 1);
//         updateProductHeartIcon(productId, false);
//       } else {
//         wishlist.push(productId.toString());
//         updateProductHeartIcon(productId, true);
//       }

//       localStorage.setItem('wishlist', JSON.stringify(wishlist));

//       updateWishlistCount();
//     } else {
//       console.warn('Wishlist toggle clicked without a product ID:', this);
//     }
//   });

//   const $wishlistHeaderToggle = $('.js-wishlist-header-toggle');
//   if ($wishlistHeaderToggle.length) {
//     $wishlistHeaderToggle.on('click', function(event) {
//       event.preventDefault();
//       console.log('Header wishlist button clicked. Current wishlist:', wishlist);
//     });
//   }

//   initializeWishlist();
// });


// Ensure the script runs after the DOM is fully loaded using jQuery's ready function
$(function() {
  // Select the header wishlist count element using jQuery
  const $wishlistCountSpan = $('.js-wishlist-count');

  // Select all individual product wishlist toggle buttons using jQuery
  const $productWishlistToggles = $('.js-wishlist-toggle');

  // Retrieve wishlist from localStorage, or initialize as an empty array if not found
  // Using JSON.parse to convert the string back to an array
  let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

  // Check if we're on the wishlist page
  const isWishlistPage = window.location.pathname.includes('/pages/wishlist') || 
                        window.location.pathname.includes('/pages/my-wishlist') ||
                        $('#wishlist-items-container').length > 0;

  /**
   * Updates the text content of the header wishlist count span.
   */
  const updateWishlistCount = () => {
    if ($wishlistCountSpan.length) { // Check if the element exists
      $wishlistCountSpan.text(wishlist.length);
    }
  };

  /**
   * Updates the Font Awesome heart icon for a specific product.
   * Changes between 'far' (regular/outline) and 'fas' (solid/filled) classes.
   * @param {string} productId - The ID of the product to update.
   * @param {boolean} isWishlisted - True if the product is wishlisted, false otherwise.
   */
  const updateProductHeartIcon = (productId, isWishlisted) => {
    // Find the icon element within the product's wishlist toggle using jQuery
    const $productToggleIcon = $(`.js-wishlist-toggle[data-product-id="${productId}"] i`);
    if ($productToggleIcon.length) { // Check if the element exists
      if (isWishlisted) {
        // If wishlisted, make it a solid heart
        $productToggleIcon.removeClass('far').addClass('fas');
      } else {
        // If not wishlisted, make it an outline heart
        $productToggleIcon.removeClass('fas').addClass('far');
      }
    }
  };

  /**
   * Fetches product data from Shopify using JSON template
   * @param {Array} productIds - Array of product IDs to fetch
   * @returns {Promise<Array>} - Promise that resolves to array of product data
   */
  const fetchProductData = async (productIds) => {
    try {
      const response = await fetch(`/products.json?ids=${productIds.join(',')}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data.products || [];
    } catch (error) {
      console.error('Error fetching product data:', error);
      return [];
    }
  };

  /**
   * Generates star rating HTML for reviews
   * @param {number} rating - Rating value (e.g., 4.5)
   * @returns {string} - HTML string for stars
   */
  const generateStarsHTML = (rating) => {
    if (!rating) return '';
    
    let starsHTML = '';
    const ratingNum = parseFloat(rating);
    const fullStars = Math.floor(ratingNum);
    
    // Add full stars
    for (let i = 1; i <= fullStars; i++) {
      starsHTML += '<i class="fas fa-star"></i>';
    }
    
    // Add remaining empty stars to make 5 total (matching your template logic)
    const emptyStars = 5 - fullStars;
    for (let i = 1; i <= emptyStars; i++) {
      starsHTML += '<i class="fas fa-star"></i>';
    }
    
    return starsHTML;
  };

  /**
   * Renders wishlist items on the wishlist page using your exact product card structure
   */
  const renderWishlistItems = async () => {
    if (!isWishlistPage) return;
    
    const $container = $('#wishlist-items-container');
    const $loading = $('#wishlist-loading');
    const $empty = $('#empty-wishlist');
    
    // Show loading state
    $loading.show();
    $container.hide();
    $empty.hide();
    
    if (wishlist.length === 0) {
      $loading.hide();
      $empty.show();
      return;
    }
    
    try {
      const products = await fetchProductData(wishlist);
      
      if (products.length === 0) {
        $loading.hide();
        $empty.show();
        return;
      }
      
      // Clear existing items
      $container.empty();
      
      // Render each product using your exact card structure
      products.forEach(product => {
        const isOnSale = product.compare_at_price && 
                        parseFloat(product.compare_at_price.replace(/[^0-9.-]+/g,"")) > 
                        parseFloat(product.price.replace(/[^0-9.-]+/g,""));
        
        const isNew = product.tags && product.tags.includes('New');
        const rating = product.metafields?.reviews?.rating?.value;
        const reviewCount = product.metafields?.reviews?.count?.value;
        
        const productHTML = `
          <div class="col-md-6 col-lg-3" data-product-id="${product.id}">
            <div class="homepagecollection__card">
              <div class="homepagecollection__cardimage">
                ${product.featured_image?.url ? 
                  `<img src="${product.featured_image.url}"
                       alt="${product.featured_image.alt || product.title}"
                       width="${product.featured_image.width || 300}"
                       height="${product.featured_image.height || 300}"
                       loading="lazy">` :
                  `<img src="https://via.placeholder.com/300x300?text=Product+Image"
                       alt="Placeholder Product Image"
                       width="300"
                       height="300">`
                }
                
                ${isOnSale ? '<div class="homepagecollection__cardlabel homepagecollection__cardlabel--sale">Sale</div>' : ''}
                ${!isOnSale && isNew ? '<div class="homepagecollection__cardlabel homepagecollection__cardlabel--new">New</div>' : ''}
                
                <div class="homepagecollection__wishlist js-wishlist-toggle" data-product-id="${product.id}">
                  <i class="fas fa-heart"></i>
                </div>
                
                <div class="wishlist-remove js-remove-from-wishlist" data-product-id="${product.id}" title="Remove from wishlist">
                  <i class="fas fa-times"></i>
                </div>
              </div>
              
              <div class="homepagecollection__cardcontent">
                ${product.vendor ? `<div class="homepagecollection__category">${product.vendor}</div>` : ''}
                
                <h3 class="homepagecollection__cardtitle">
                  <a href="${product.url}">${product.title}</a>
                </h3>
                
                ${rating ? `
                  <div class="homepagecollection__rating">
                    <div class="homepagecollection__stars">
                      ${generateStarsHTML(rating)}
                    </div>
                    ${reviewCount ? `<span class="homepagecollection__reviews">(${reviewCount} review${reviewCount !== '1' ? 's' : ''})</span>` : ''}
                  </div>
                ` : ''}
                
                <div class="homepagecollection__price">
                  ${isOnSale ? 
                    `<span class="price-new">${product.price}</span>
                     <span class="price-old">${product.compare_at_price}</span>` : 
                    product.price
                  }
                </div>
                
                <div class="homepagecollection__actions">
                  <input type="number" class="homepagecollection__quantity js-qty-input" value="1" min="1" 
                         data-product-variant-id="${product.selected_or_first_available_variant?.id}">
                  <button class="homepagecollection__addtocart js-add-to-cart" 
                          data-product-variant-id="${product.selected_or_first_available_variant?.id}"
                          ${!product.available ? 'disabled' : ''}>
                    ${product.available ? 
                      '<i class="fas fa-shopping-cart"></i> ADD TO CART' : 
                      'Sold Out'
                    }
                  </button>
                </div>
              </div>
            </div>
          </div>
        `;
        
        $container.append(productHTML);
      });
      
      $loading.hide();
      $container.show();
      
    } catch (error) {
      console.error('Error rendering wishlist items:', error);
      $loading.hide();
      $empty.show();
    }
  };

  /**
   * Removes product from wishlist page DOM with animation
   */
  const removeProductFromWishlistPage = (productId) => {
    if (isWishlistPage) {
      $(`[data-product-id="${productId}"]`).fadeOut(300, function() {
        $(this).remove();
        
        // Check if wishlist is empty after removal
        if ($('#wishlist-items-container').children().length === 0) {
          $('#empty-wishlist').show();
          $('#wishlist-items-container').hide();
        }
      });
    }
  };

  /**
   * Initializes the wishlist state on page load.
   * - Iterates through the current wishlist items in localStorage.
   * - Updates the heart icon for each wishlisted product.
   * - Sets the initial header wishlist count.
   */
  const initializeWishlist = () => {
    wishlist.forEach(productId => {
      updateProductHeartIcon(productId, true); // Mark as wishlisted
    });
    updateWishlistCount(); // Set the initial count
    
    // If on wishlist page, render items
    if (isWishlistPage) {
      renderWishlistItems();
    }
  };

  /**
   * Event listener for individual product wishlist toggles.
   * Adds or removes the product from the wishlist and updates the UI.
   * Using jQuery's .on() for event delegation (works on dynamically added elements too).
   */
  $(document).on('click', '.js-wishlist-toggle', function(event) {
    event.preventDefault(); // Prevent default link behavior

    // Get the product ID from the data-product-id attribute using jQuery's .data()
    const productId = $(this).data('product-id');

    if (productId) {
      // Check if the product is already in the wishlist
      const index = wishlist.indexOf(productId.toString()); // Ensure string comparison

      if (index > -1) {
        // Product is in wishlist, so remove it
        wishlist.splice(index, 1);
        updateProductHeartIcon(productId, false); // Update icon to outline
        removeProductFromWishlistPage(productId); // Remove from page if on wishlist page
      } else {
        // Product is not in wishlist, so add it
        wishlist.push(productId.toString()); // Ensure string consistency
        updateProductHeartIcon(productId, true); // Update icon to solid
      }

      // Save the updated wishlist back to localStorage
      localStorage.setItem('wishlist', JSON.stringify(wishlist));

      // Update the header count
      updateWishlistCount();
    } else {
      console.warn('Wishlist toggle clicked without a product ID:', this);
    }
  });

  /**
   * Event listener for removing items directly from wishlist page
   */
  $(document).on('click', '.js-remove-from-wishlist', function(event) {
    event.preventDefault();
    const productId = $(this).data('product-id');
    
    if (productId) {
      const index = wishlist.indexOf(productId.toString());
      if (index > -1) {
        wishlist.splice(index, 1);
        localStorage.setItem('wishlist', JSON.stringify(wishlist));
        updateProductHeartIcon(productId, false);
        updateWishlistCount();
        removeProductFromWishlistPage(productId);
      }
    }
  });

  /**
   * Event listener for add to cart buttons (works on wishlist page too)
   */
//   $(document).on('click', '.js-add-to-cart', function(event) {
//     event.preventDefault();
    
//     const $button = $(this);
//     const variantId = $button.data('product-variant-id');
//     const $qtyInput = $button.siblings('.js-qty-input');
//     const quantity = parseInt($qtyInput.val()) || 1;
    
//     if (!variantId) {
//       console.error('No variant ID found');
//       return;
//     }
    
//     const originalText = $button.html();
//     $button.prop('disabled', true).html('<i class="fas fa-spinner fa-spin"></i> Adding...');
    
//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({
//         id: variantId,
//         quantity: quantity
//       })
//     })
//     .then(response => response.json())
//     .then(data => {
//       $button.html('<i class="fas fa-check"></i> Added!');
//       setTimeout(() => {
//         $button.prop('disabled', false).html(originalText);
//       }, 2000);
//     })
//     .catch(error => {
//       console.error('Error adding to cart:', error);
//       $button.prop('disabled', false).html(originalText);
//     });
//   });

//   const $wishlistHeaderToggle = $('.js-wishlist-header-toggle');
//   if ($wishlistHeaderToggle.length) {
//     $wishlistHeaderToggle.on('click', function(event) {
//       event.preventDefault();
//       window.location.href = '/pages/wishlist';
//     });
//   }

//   window.addEventListener('storage', function(e) {
//     if (e.key === 'wishlist') {
//       wishlist = JSON.parse(e.newValue) || [];
//       updateWishlistCount();
      
//       if (isWishlistPage) {
//         renderWishlistItems();
//       }
//     }
//   });
//   initializeWishlist();
});


// FAQs
$(document).ready(function() {
            // FAQ accordion functionality
            $('.faq-question').on('click', function() {
                const $faqItem = $(this).parent();
                const isActive = $faqItem.hasClass('active');

                // Close all other FAQ items
                $('.faq-item').removeClass('active');

                // Toggle current item
                if (!isActive) {
                    $faqItem.addClass('active');
                }
            });
        });

        
document.addEventListener('DOMContentLoaded', function() {
    // Get references to your search elements
    const searchOverlay = document.getElementById('search-overlay');
    const searchInput = searchOverlay ? searchOverlay.querySelector('.search-input') : null;
    const searchSubmitButton = searchOverlay ? searchOverlay.querySelector('.search-submit') : null;
    const suggestionItems = document.querySelectorAll('.suggestion-item');

    // Proceed only if the essential search elements exist
    if (searchInput && searchSubmitButton) {

        // Function to perform the search
        function performSearch() {
            const query = searchInput.value.trim(); // Get the input value and remove whitespace
            if (query) { // Only search if the query is not empty
                // Redirect to Shopify's default search results page
                // encodeURIComponent ensures special characters in the query are handled correctly
                window.location.href = `/search?q=${encodeURIComponent(query)}`;
                // If you want to automatically close the overlay after search, uncomment the line below
                // searchOverlay.classList.remove('is-active'); // Assuming 'is-active' class controls visibility
            }
        }

        // Event listener for the search submit button
        searchSubmitButton.addEventListener('click', function(event) {
            event.preventDefault(); // Prevent default form submission behavior
            performSearch(); // Call the search function
        });

        // Event listener for the 'Enter' key press in the search input field
        searchInput.addEventListener('keydown', function(event) {
            if (event.key === 'Enter') {
                event.preventDefault(); // Prevent default form submission behavior
                performSearch(); // Call the search function
            }
        });

        // Event listeners for "Popular Searches" suggestion items
        suggestionItems.forEach(item => {
            item.addEventListener('click', function(event) {
                event.preventDefault(); // Prevent default link behavior (e.g., navigating to '#')
                const searchTerm = this.textContent; // Get the text content of the clicked suggestion
                searchInput.value = searchTerm; // Populate the search input with the suggestion
                performSearch(); // Perform the search with the suggestion
            });
        });

    } else {
        console.warn("Shopify Search Functionality: Required search input or submit button not found. Please check your HTML.");
    }
});